import React from 'react';
import registeredComponent from "../../utils/registeredComponent";

import './styles/BillingAccountAccessPicker.scss';
import { filterDuck, duckify } from "../../utils/duckify";
import { billingPayers as billingPayersDuck, contacts as contactsDuck } from '../../ducks';

import BillingPayerToBillingAccountMapper from "./BillingPayerToBillingAccountMapper";

const BillingAccountAccessPickerList = ({kidContactId, payerContacts, billingPayers}) => {
  return <React.Fragment>
    {payerContacts.map((contact, i) => {
      return <BillingPayerToBillingAccountMapper key={i} kidContactId={kidContactId} payerContact={contact} billingPayer={billingPayers.find((payer) => payer.payer_contact.id === contact.id)} />;
    })}
  </React.Fragment>;
};

const mapDucksToProps = (props) => {
  return {
    payerContacts: filterDuck(contactsDuck, { contact_id: props.kidContactId, financial: true }),
    billingPayers: filterDuck(billingPayersDuck, {contact_id: props.kidContactId})
  }
};

export default registeredComponent('BillingAccountAccessPickerList')(duckify(mapDucksToProps, () => ({}), () => ({}))(BillingAccountAccessPickerList));
